import Vue from 'vue'
import Vuex from 'vuex'
import user from './store'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production', //在非生产环境下，使用严格模式
    modules: {
        user
    }
})


// WEBPACK FOOTER //
// ./vuex/index.js